export const enum PoiTypeGroup {
  Warnings = 'warnings',
  Information = 'information',
}

export interface PoiTypeDefinition {
  /** POIType_TranslationKey */
  key: string;
  iconKey: string;
  iconColor: string;
  group: PoiTypeGroup;
}

export const WarningPoiSeverities = ['Critical', 'Warning'];

const warning = (key: string, iconKey: string, iconColor: string): PoiTypeDefinition => ({
  key,
  iconKey,
  iconColor,
  group: PoiTypeGroup.Warnings,
});

const information = (key: string, iconKey: string, iconColor: string): PoiTypeDefinition => ({
  key,
  iconKey,
  iconColor,
  group: PoiTypeGroup.Information,
});

export const KnownPoiTypes: PoiTypeDefinition[] = [
  warning('poi.ski.crossing', 'icon-question-trail', 'red'),
  warning('poi.ski.machine.risk', 'icon-snowcat-warning', '#DD0C00'),
  warning('poi.ski.obstacle.hidden', 'icon-rock', 'orange'),
  warning('poi.ski.road.highspeed', 'icon-road-80', '#DD0C00'),
  warning('poi.ski.surface.slippery', 'icon-slippery', 'black'),
  warning('poi.ski.hill.long_descent', 'icon-slope-long', 'orange'),
  warning('poi.ski.ice.nearby_lake', 'icon-lake-ice', '#DD0C00'),
  warning('poi.ski.ice.overflow', 'icon-water-on-ice', '#DD0C00'),
  warning('poi.ski.road.crossing', 'icon-road-crossing', 'black'),
  warning('poi.ski.surface.soft_wet', 'icon-soft-snow', 'orange'),
  warning('poi.ski.hill.uphill', 'icon-slope-up', 'orange'),
  warning('poi.ski.hill.downhill', 'icon-slope-down', '#FFA700'),
  warning('poi.ski.hill.technical_turn', 'icon-slope-turn', '#DD0C00'),
  warning('poi.ski.ice.unsafe', 'icon-ice-crack', '#DD0C00'),
  warning('poi.ski.wayfinding.unclear', 'icon-question-trail', 'black'),
  information('poi.ski.facility.bus_stop', 'icon-bus-stop', 'blue'),
  information('poi.ski.facility.cabin', 'icon-cabin', 'green'),
  information('poi.ski.facility.cafe', 'icon-cafe', 'blue'),
  information('poi.ski.road.gravel', 'icon-road-gravel', 'orange'),
  information('poi.ski.info', 'icon-info', 'blue'),
  information('poi.ski.intersection.major', 'icon-trail-junction', 'blue'),
  information('poi.ski.facility.parking', 'icon-parking', 'blue'),
  information('poi.ski.facility.shop', 'icon-shop', 'blue'),
  information('poi.ski.direction.turn_left', 'icon-turn-left', 'blue'),
  information('poi.ski.direction.turn_right', 'icon-turn-right', 'blue'),
  information('poi.ski.webcamera', 'camera_filled', 'blue'),
];
